import chroma from 'chroma-js'
import _ from 'lodash'
import { useMessages } from '../composables/useMessages'
import { getAllCategoriaDeArvore } from '../services/requests/CategoriaDeArvoreRequests'
import { listarCategoriasDeFitossanidade } from '../services/requests/CategoriaDeFitossanidadeRequests'
import { corrigirMedicao } from '../services/requests/MedicoesInventarioRequests'
import {
	espacamentoToObject,
	limiteMaximoMedicoesParcela,
	limiteMinimoMedicoesParcela,
	parseDate,
} from '../utils/helpers'

import { parse } from 'date-fns'

const { addMessage } = useMessages()

import Papa from 'papaparse'

import { v4 as uuidv4 } from 'uuid'

import { mapMutations } from 'vuex'
import i18n from '../VueI18n'

const mixins = {
	data() {
		return {
			dadosValidacaoConsistencia: [],

			medicaoAlterada: false,
			salvandoAlteracoes: false,
			medicoesDesconsideradas: [],
			medicoesAtualizadas: [],
			arvores: [],
			colunaAtributo: [],
			file: undefined,
			content: { errors: [], data: [] },
			parsed: false,
			boxPlotSensibility: 2,
			dataMedicao: [],
			categorias: [],
			categoriasFito: [],
			plantios: [],
			preenchimentoCategoria: {
				//"Presença Obrigatória", //COM
				C: (atributo) => {
					return atributo && atributo > 0
				},
				//"Ausência Obrigatória", //SEM
				S: (atributo) => {
					return !atributo
				},
				//"Opcional"
				O: (atributo) => {
					return atributo && atributo
				},
			},
		}
	},
	async mounted() {
		// this.dataMedicao = medicoes
		const categorias = await getAllCategoriaDeArvore()
		this.categorias = categorias.data.result

		const categoriasFito = await listarCategoriasDeFitossanidade()
		this.categoriasFito = categoriasFito.data
	},

	methods: {
		...mapMutations('moduleMessages', ['mutationShowMessage']),
		findEstrato() {
			const estrato = (this.estratos || this.estratosFlorestais).find(
				(f) => f.id === this.model.fk_esfl_estrato_florestal,
			)
			return estrato
		},
		async salvarAlteracoes() {
			this.salvandoAlteracoes = true

			var response = await corrigirMedicao({
				idsDeArvoresParaExcluir: this.medicoesDesconsideradas,
				idMedicao: this.model.fk_mdco_medicao ? this.model.fk_mdco_medicao : this.model.id,
				arvoresParaAtualizar: this.medicoesAtualizadasFormatadas,
				correcoes: [], // Campo obrigatório pela API
			})

			if (response.status === 200) {
				addMessage({ description: this.$t('alteracaoSalva'), type: 'success' })
				this.medicoesAtualizadas = []
				this.medicoesDesconsideradas = []
			} else {
				addMessage({ description: this.$t('naoFoiPossivelSalvarAlteracao'), type: 'error' })
			}

			this.salvandoAlteracoes = false
		},
		desconsiderar(ids) {
			this.medicoesDesconsideradas = ids
		},
		changePoint(point) {
			this.medicoesNormalizadas.forEach((f) => {
				if (f.id === point.id || f.idArvore === point.id) {
					this.medicoesAtualizadas.push(f.id || f.idArvore)
					f[this.bindColunas.dap] = point.dap
					f[this.bindColunas.ht] = point.ht
					f[this.bindColunas.categoriaDaArvore] = point.categoriaDaArvore
					f[this.bindColunas.categoriaFitossanidade] = point.categoriaFitossanidade
					f[this.bindColunas.intensidadeFitossanidade] = point.intensidadeFitossanidade
					f[this.bindColunas.coberturaMatoLinha] = point.coberturaMatoLinha
					f[this.bindColunas.coberturaMatoEntrelinha] = point.coberturaMatoEntrelinha
					f[this.bindColunas.alturaMatoLinha] = point.alturaMatoLinha
					f[this.bindColunas.alturaMatoEntrelinha] = point.alturaMatoEntrelinha
					f[this.bindColunas.matoAssociadoEntrelinha] = point.matoAssociadoEntrelinha
					f[this.bindColunas.matoDominanteEntrelinha] = point.matoDominanteEntrelinha
					f[this.bindColunas.tipoMatoAssociado] = point.tipoMatoAssociado
					f[this.bindColunas.tipoMatoDominante] = point.tipoMatoDominante
					f[this.bindColunas.diametroCopa] = point.diametroCopa
				}
			})

			this.medicaoAlterada = true
		},

		parseDateFunction(dateStr) {
			return parse(dateStr, 'dd/MM/yyyy', new Date())
		},

		handleFileUpload(event) {
			if (event instanceof File) {
				this.file = event
				this.parseFile()
			}
		},
		parseFile() {
			Papa.parse(this.file, {
				header: true,
				encoding: 'utf-8-sig',
				skipEmptyLines: true,
				complete: function (results) {
					// Filtra registros em branco
					results.data = results.data.filter((row) =>
						Object.values(row).some((value) => value.trim() !== ''),
					)
					this.content = results
					this.parsed = true
					this.colunaAtributo = this.content.errors.length
						? []
						: this.colunasMapeamento.map((coluna) => {
								return {
									coluna: coluna.nome,
									value: coluna.key,
									key:
										Object.keys(results.data[0])
											.map((m) => {
												return { value: m, label: m }
											})
											.find((f) => new RegExp(coluna.regex).test(f.label))?.label || 'Nenhum',
								}
							})

					results.data.forEach((medicao) => {
						medicao.id = uuidv4()
						medicao.nivelRisco = ''
						medicao[this.bindColunas.dap] = isNaN(parseFloat(medicao[this.bindColunas.dap]))
							? undefined
							: parseFloat(medicao[this.bindColunas.dap]?.toString()?.replace(',', '.'))
						medicao[this.bindColunas.cap] = isNaN(parseFloat(medicao[this.bindColunas.cap]))
							? undefined
							: parseFloat(medicao[this.bindColunas.cap]?.toString()?.replace(',', '.'))
						medicao[this.bindColunas.ht] = isNaN(parseFloat(medicao[this.bindColunas.ht]))
							? undefined
							: parseFloat(medicao[this.bindColunas.ht]?.toString()?.replace(',', '.'))
					})
				}.bind(this),
			})
		},
		// função foi para dentro do componente OutliersChart.vue
		limitesDAPHTxIdade(idade) {
			//limite de aviso superior
			const LAS =
				1.4459113233 +
				-0.3613213214 * idade +
				0.0698935354 * Math.pow(idade, 2) +
				-0.0046931676 * Math.pow(idade, 3) +
				0.0001022883 * Math.pow(idade, 4)
			//limite de aviso inferior
			const LAI =
				7.442517e-1 +
				-1.403595e-1 * idade +
				2.243259e-2 * Math.pow(idade, 2) +
				-1.358378e-3 * Math.pow(idade, 3) +
				2.856334e-5 * Math.pow(idade, 4)
			//limite de erro superior
			const LES = LAS + LAS * 0.15
			//limite de erro inferior
			const LEI = LAI + LAI * 0.15

			return {
				LAS,
				LAI,
				LES,
				LEI,
			}
		},
		limitesDAPxIdade(idade) {
			//limite de aviso superior
			const LAS = Math.exp(2.3841275 + 0.5272372 * Math.log(idade))
			//limite de aviso inferior
			const LAI = Math.exp(1.130681 + 0.4357873 * Math.log(idade))
			//limite de erro superior
			const LES = LAS + LAS * 0.15
			//limite de erro inferior
			const LEI = LAI + LAI * 0.15

			return {
				LAS,
				LAI,
				LES,
				LEI,
			}
		},
		/**
		 * Valida se categoria da arvore da medição, faz referencia a um das categorias presentes no sistema
		 * caso negativo, adiciona como inconsistência na lista de inconsistencias da medicao (medicao.inconsistencias)
		 */
		validaCategoriaArvoreMedicao(medicao) {
			const categoriasArvore = this.categorias.map((categoria) => categoria.ctga_nm_nome)

			if (!categoriasArvore.includes(medicao[this.bindColunas.categoriaDaArvore]))
				medicao.inconsistencias.push(
					'Categoria não cadastrada no sistema: ' + medicao[this.bindColunas.categoriaDaArvore],
				)
		},
		/**
		 * Valida se caso a medição estiver marcada como BIFURCADA, TRIFURCADA ou MULTIFUSTES, quantidade de fustes
		 * atende o conceito da categoria
		 */
		validaCategoriaFustes(medicao) {
			const message = `Número de fustes diferente do conceito da categoria: ${
				medicao[this.bindColunas.categoriaDaArvore]
			} com ${medicao[this.bindColunas.fuste]} fustes.`

			if (
				medicao[this.bindColunas.categoriaDaArvore] === 'BIFURCADA' &&
				medicao[this.bindColunas.fuste] != 2
			) {
				medicao.inconsistencias.push(message)
			} else if (
				medicao[this.bindColunas.categoriaDaArvore] === 'TRIFURCADA' &&
				medicao[this.bindColunas.fuste] != 3
			) {
				medicao.inconsistencias.push(message)
			} else if (
				medicao[this.bindColunas.categoriaDaArvore] === 'MULTIFUSTES' &&
				medicao[this.bindColunas.fuste] > 3
			) {
				medicao.inconsistencias.push(message)
			}
		},
		/**
		 * Valida se código de plantio de medição, faz referencia a um dos plantios do estrato escolhido
		 * caso negativo, adiciona como inconsistência na lista de inconsistencias da medicao (medicao.inconsistencias)
		 */
		validaCodigoPlantio(medicao) {
			const codigosPlantios = this.plantios.map(
				(plantio) => plantio.plaes_tbg_ptio_plantio.ptio_cd_codigo,
			)

			if (!codigosPlantios.includes(medicao[this.bindColunas.plantio]))
				medicao.inconsistencias.push(
					'Estrato Florestal não possui plantio com código: ' + medicao[this.bindColunas.plantio],
				)
		},
		/**
		 * Valida se data de plantio presente na medição é o mesmo que faz referencia no estrato escolhido
		 * caso negativo, adiciona como inconsistencia na lista de inconsistencias da medicao
		 */
		validaDataColeta(medicao) {
			if (medicao[this.bindColunas.dataPlantio && medicao[this.bindColunas.dataColeta]]) {
				let dataPlantio = parseDate(medicao[this.bindColunas.dataPlantio])
				let dataColeta = parseDate(medicao[this.bindColunas.dataColeta])

				if (!dataPlantio.isValid()) {
					medicao.inconsistencias.push('Data de plantio não é uma data válida')
				}

				if (!dataColeta.isValid()) {
					medicao.inconsistencias.push('Data de coleta não é uma data válida')
				}

				let plantioReferencia = this.plantios.find(
					(plantio) => plantio.ptio_cd_codigo === medicao[this.bindColunas.plantio],
				)

				if (dataPlantio.getTime() > dataColeta.getTime())
					medicao.inconsistencias.push('Data de plantio é maior que data de coleta')

				if (
					plantioReferencia &&
					new Date(plantioReferencia.ptio_dt_plantio).getTime() != dataPlantio.getTime()
				) {
					medicao.inconsistencias.push('Data de plantio não consta no sistema')
				}
			}
		},
		validaLinha(medicao) {
			const linha = Number(medicao[this.bindColunas.linha]?.toString().replace(',', '.'))
			const isNan = isNaN(linha)

			if (isNan) {
				medicao.inconsistencias.push('Linha deve ser um número')
			}

			if (!isNan && linha < 0) {
				medicao.inconsistencias.push('Linha deve ser um número maior que 0')
			}
		},
		validaArvore(medicao) {
			const arvore = Number(medicao[this.bindColunas.arvore]?.toString().replace(',', '.'))
			const isNan = isNaN(arvore)

			if (isNan) {
				medicao.inconsistencias.push('Árvore deve ser um número')
			}

			if (!isNan && arvore < 0) {
				medicao.inconsistencias.push('Árvore deve ser um número maior que 0')
			}
		},
		validaCAP(medicao) {
			if (medicao[this.bindColunas.cap]) {
				const cap = Number(medicao[this.bindColunas.cap]?.toString().replace(',', '.'))
				const isNan = isNaN(cap)

				if (isNan) {
					medicao.inconsistencias.push('CAP deve ser um número')
				}

				if (!isNan && cap < 0) {
					medicao.inconsistencias.push('CAP deve ser um número maior que 0')
				}
			}
		},
		validaDAP(medicao) {
			if (medicao[this.bindColunas.dap]) {
				const dap = Number(medicao[this.bindColunas.dap]?.toString().replace(',', '.'))
				const isNan = isNaN(dap)

				if (medicao[this.bindColunas.dap]) {
					if (isNan) {
						medicao.inconsistencias.push('DAP deve ser um número')
					}

					if (!isNan && dap < 0) {
						medicao.inconsistencias.push('DAP deve ser um número maior que 0')
					}
				}
			}
		},
		validaHT(medicao) {
			if (medicao[this.bindColunas.ht]) {
				const ht = Number(medicao[this.bindColunas.ht]?.toString().replace(',', '.'))
				const isNan = isNaN(ht)

				if (medicao[this.bindColunas.ht]) {
					if (isNan) {
						medicao.inconsistencias.push('HT deve ser um número')
					}

					if (!isNan && ht < 0) {
						medicao.inconsistencias.push('HT deve ser um número maior que 0')
					}
				}
			}
		},
		validaInclinacao(medicao) {
			if (medicao[this.bindColunas.inclinacao]) {
				const inclinacao = Number(
					medicao[this.bindColunas.inclinacao]?.toString().replace(',', '.'),
				)
				const isNan = isNaN(inclinacao)

				if (isNan) {
					medicao.inconsistencias.push('Inclinacao deve ser um número')
				}
			}
		},
		validaFuste(medicao) {
			const fuste = Number(medicao[this.bindColunas.fuste]?.toString().replace(',', '.'))
			const isNan = isNaN(fuste)

			if (isNan) {
				medicao.inconsistencias.push('Fuste deve ser um número')
			}

			if (!isNan && fuste < 0) {
				medicao.inconsistencias.push('Fuste deve ser um número maior que 0')
			}
		},
		validaAreaParcela(medicao) {
			const area = Number(medicao[this.bindColunas.areaPar]?.toString().replace(',', '.'))
			const isNan = isNaN(area)
			if (isNan) {
				medicao.inconsistencias.push('Área da parcela deve ser um número')
			}

			if (!isNan && area < 0) {
				medicao.inconsistencias.push('Área da parcela não pode ser um número negativo')
			}
		},
		/**
		 * Valida se regras de categoria estão sendo respeitadas, caso negativo adiciona como inconsistencia na lista de de inconsistencias da medição
		 */
		verificaPreenchimento(medicao) {
			const categoria = this.categorias.find(
				(categoria) => categoria.ctga_nm_nome === medicao[this.bindColunas.categoriaDaArvore],
			)

			if (categoria) {
				const { ctga_tp_valida_dap, ctga_tp_valida_ht, ctga_nm_nome } = categoria
				if (
					medicao[this.bindColunas.ht] && //verifica se altura não é nula
					ctga_tp_valida_ht === 'C' &&
					!this.preenchimentoCategoria[ctga_tp_valida_ht](
						Number(medicao[this.bindColunas.ht]?.toString().replace(',', '.')),
					)
				) {
					medicao.inconsistencias.push(
						'Presença de HT Obrigatória por ser de categoria ' + ctga_nm_nome,
					)
				}
				if (
					medicao[this.bindColunas.dap] && //verifica se DAP não é nulo
					ctga_tp_valida_dap === 'C' &&
					!this.preenchimentoCategoria[ctga_tp_valida_dap](
						Number(medicao[this.bindColunas.dap]?.toString().replace(',', '.')),
					)
				) {
					medicao.inconsistencias.push(
						'Presença de DAP Obrigatória por ser de categoria ' + ctga_nm_nome,
					)
				}

				if (
					medicao[this.bindColunas.dap] && // verifica se DAP não é nulo
					ctga_tp_valida_dap === 'S' &&
					!this.preenchimentoCategoria[ctga_tp_valida_dap](
						Number(medicao[this.bindColunas.dap]?.toString().replace(',', '.')),
					)
				) {
					medicao.inconsistencias.push(
						'Ausência de DAP Obrigatória por ser de categoria ' + ctga_nm_nome,
					)
				}

				if (
					medicao[this.bindColunas.ht] && //verifica se altura não é  nula
					ctga_tp_valida_dap === 'S' &&
					!this.preenchimentoCategoria[ctga_tp_valida_ht](
						Number(medicao[this.bindColunas.ht]?.toString().replace(',', '.')),
					)
				) {
					medicao.inconsistencias.push(
						'Ausência de HT Obrigatória por ser de categoria ' + ctga_nm_nome,
					)
				}
			}
		},
	},
	computed: {
		ableToSave() {
			return (
				this.medicoesAtualizadasFormatadas.length > 0 || this.medicoesDesconsideradas.length > 0
			)
		},
		corCategoria() {
			return Object.fromEntries(
				this.categorias.map(({ ctga_nm_nome, ctga_tx_cor }) => [
					ctga_nm_nome,
					ctga_tx_cor || chroma.random().hex(),
				]),
			)
		},
		corCategoriaFitossanidade() {
			return Object.fromEntries(
				this.categoriasFito.map(({ nome, cor }) => [nome, cor || chroma.random().hex()]),
			)
		},
		colunasCadastrais() {
			return [
				{
					nome: i18n.t('section'),
					key: 'talhao',
					descricao: i18n.t('deveConterCodigoTalhao'),
					exemplo: 'T-01',
					formato: 'text',
					regex: new RegExp('t.*lh', 'gi'),
					validator: (value) => {
						return !value ? 'Código do Talhão não pode estar vazio' : null
					},
				},
				{
					nome: i18n.t('plantation'),
					key: 'plantio',
					descricao: i18n.t('deveConterCodigoPlantio'),
					exemplo: 'P-01',
					formato: 'text',
					regex: new RegExp('p.*l.*t', 'gi'),
					validator: (value) => {
						return !value
							? 'Código do Plantio não pode estar vazio'
							: !this.plantios
										.map((plantio) => plantio.plaes_tbg_ptio_plantio.ptio_cd_codigo)
										.includes(value)
								? 'Estrato Florestal não possui plantio com código: ' + value
								: null
					},
				},
				{
					nome: i18n.t('plot'),
					key: 'parcela',
					descricao: i18n.t('deveConterCodigoParcela'),
					exemplo: 'P-01',
					formato: 'text',
					regex: new RegExp('p.*r.*c', 'gi'),
					validator: (value) => {
						return !value ? 'Código da Parcela não pode estar vazio' : null
					},
				},
				{
					nome: i18n.t('plotArea'),
					key: 'areaParc',
					unidade: '(m²)',
					descricao: i18n.t('deveConterAreaParcela'),
					exemplo: '400',
					formato: 'number',
					regex: new RegExp('a.*r.*p.*r.*c', 'gi'),
					validator: (value) => {
						const normalizado = value?.toString().trim().replace(',', '.')
						if (normalizado === undefined || normalizado === null || normalizado === '')
							return i18n.t('areaParcelaObrigatoria')
						const numero = Number(normalizado)
						if (isNaN(numero)) return i18n.t('areaParcelaInvalida')
						if (numero <= 0) return i18n.t('areaParcelaMaiorQueZero')
						return null
					},
				},
				{
					nome: i18n.t('plantationDate'),
					key: 'dataPlantio',
					descricao: i18n.t('deveConterDataPlantio'),
					exemplo: '10/05/2016',
					formato: 'text',
					regex: new RegExp('d.*t.*p.*l', 'gi'),
					validator: (value) => {
						return value
							? parseDate(value).isValid()
								? null
								: 'Data do Plantio deve ser uma data válida'
							: null
					},
				},
			]
		},
		colunasColeta() {
			return [
				{
					nome: i18n.t('collectDate'),
					key: 'dataColeta',
					descricao: i18n.t('deveConterDataParcela'),
					exemplo: '10/05/2016',
					formato: 'text',
					regex: new RegExp('d.*t.*c.*l.*t', 'gi'),
					validator: (value) => {
						// Validator de celula: roda no DataMapper independente de podeIniciarValidacaoEstrutural,
						// entao e aqui que a data de coleta vazia fica visivel mesmo com outros erros de mapeamento.
						const valor = value?.toString().trim()
						if (!valor) return i18n.t('dataColetaObrigatoria')
						return parseDate(valor).isValid() ? null : i18n.t('dataColetaInvalida')
					},
				},
				{
					nome: i18n.t('linha'),
					key: 'linha',
					descricao: i18n.t('deveConterNumeroLinha'),
					exemplo: '1',
					formato: 'number',
					regex: new RegExp('l.*nh', 'gi'),
					validator: (value) => {
						return isNaN(Number(value?.toString()?.replace(',', '.'))) ||
							Number(value?.toString()?.replace(',', '.')) < 0
							? 'Linha não pode ser um número negativo'
							: null
					},
				},
				{
					nome: i18n.t('tree'),
					key: 'arvore',
					descricao: i18n.t('deveConterNumeroArvores'),
					exemplo: '1',
					formato: 'number',
					regex: new RegExp('a.*rv', 'gi'),
					validator: (value) => {
						return isNaN(Number(value?.toString()?.replace(',', '.'))) ||
							Number(value?.toString()?.replace(',', '.')) < 0
							? 'Árvore não pode ser um número negativo'
							: null
					},
				},
				{
					nome: i18n.t('fuste'),
					key: 'fuste',
					descricao: i18n.t('deveConterNumeroFuste'),
					exemplo: '1',
					formato: 'number',
					regex: new RegExp('f.*st', 'gi'),
					validator: (value) => {
						return isNaN(Number(value?.toString()?.replace(',', '.'))) ||
							Number(value?.toString()?.replace(',', '.')) < 0
							? 'Fuste não pode ser um número negativo'
							: null
					},
				},
				{
					nome: i18n.t('hbc'),
					key: 'cap',
					unidade: '(cm)',
					descricao: i18n.t('deveConterNumeroMedidoCAP'),
					exemplo: '23,22',
					formato: 'number',
					regex: new RegExp('cap', 'gi'),
					validator: (value) => {
						return value
							? isNaN(Number(value?.toString()?.replace(',', '.'))) || value < 0
								? 'CAP não pode ser um número negativo'
								: null
							: null
					},
				},
				{
					nome: i18n.t('hbd'),
					unidade: '(cm)',
					key: 'dap',
					descricao: i18n.t('deveConterNumeroMedidoDAP'),
					exemplo: '23,22',
					formato: 'number',
					regex: new RegExp('dap', 'gi'),
					validator: (value) => {
						return value
							? isNaN(Number(value?.toString().replace(',', '.'))) || value < 0
								? 'DAP não pode ser um número negativo'
								: null
							: null
					},
					eixos: ['x', 'y'],
				},
				{
					nome: i18n.t('ht'),
					unidade: '(m)',
					key: 'ht',
					descricao: i18n.t('deveConterNumeroMedidoAltura'),
					exemplo: '23,22',
					formato: 'number',
					regex: new RegExp('ht', 'gi'),
					validator: (value) => {
						return value
							? isNaN(Number(value?.toString().replace(',', '.'))) || value < 0
								? 'HT não pode ser um número negativo'
								: null
							: null
					},
					eixos: ['x', 'y'],
				},
				{
					nome: i18n.t('treetopDiameter'),
					unidade: '(cm)',
					key: 'diametroCopa',
					descricao: i18n.t('deveConterDiametroCopa'),
					exemplo: '23,22',
					formato: 'number',
					regex: new RegExp('diam', 'gi'),
					validator: (value) => {
						return value
							? isNaN(Number(value?.toString().replace(',', '.'))) || value < 0
								? 'HT não pode ser um número negativo'
								: null
							: null
					},
					eixos: ['x', 'y'],
				},
				{
					nome: i18n.t('treeCategory'),
					key: 'categoriaDaArvore',
					descricao: i18n.t('deveConterDescricaoCategoriaArvore'),
					exemplo: 'DOMINANTE',
					formato: 'text',
					regex: new RegExp('c.*t.*g.*a', 'gi'),
					eixos: ['x'],
					validator: (value) => {
						return !this.categorias.map((categoria) => categoria.ctga_nm_nome).includes(value)
							? 'Categoria não cadastrada no sistema: ' + value
							: null
					},
				},
				{
					nome: i18n.t('fitoCategory'),
					key: 'categoriaFitossanidade',
					descricao: i18n.t('descricaoCategoriaFitossanidade'),
					exemplo: 'SAUDÁVEL',
					formato: 'text',
					regex: new RegExp('fit', 'g'),
					eixos: ['x'],
					qualidade: true,
				},
				{
					nome: i18n.t('fitoIntensity'),
					key: 'intensidadeFitossanidade',
					unidade: '(%)',
					descricao: i18n.t('descricaoIntensidadeFitossanidade'),
					exemplo: '0',
					formato: 'text',
					regex: new RegExp('in.*fit', 'g'),
					qualidade: true,
				},
				{
					nome: i18n.t('slope'),
					key: 'inclinacao',
					descricao: i18n.t('deveConterNumeroInclinacao'),
					exemplo: '15,05',
					formato: 'number',
					regex: new RegExp('incl', 'gi'),
					validator: (value) => {
						return value
							? isNaN(Number(value?.toString().replace(',', '.')))
								? 'Inclinação deve ser um número'
								: null
							: null
					},
				},
				{
					nome: i18n.t('xCoordinate'),
					key: 'coordenadaX',
					descricao: i18n.t('deveConterLongitute'),
					exemplo: '-45.8944638',
					formato: 'text',
					regex: new RegExp('coord.*x', 'gi'),
				},
				{
					nome: i18n.t('yCoordinate'),
					key: 'coordenadaY',
					descricao: i18n.t('deveConterLatitude'),
					exemplo: '-23.2049009',
					formato: 'text',
					regex: new RegExp('coord.*y', 'gi'),
				},
			]
		},
		colunasMatoCompeticao() {
			return [
				{
					nome: i18n.t('dominantBushType'),
					unidade: '(linha)',
					key: 'tipoMatoDominante',
					descricao: i18n.t('deveConterMatoDominante'),
					exemplo: 'GRAMÍNEA',
					formato: 'text',
					regex: new RegExp('mato.*d.*en', 'gi'),
					eixos: ['x'],
					qualidade: true,
				},
				{
					nome: i18n.t('associatedBushType'),
					unidade: '(linha)',
					key: 'tipoMatoAssociado',
					descricao: i18n.t('deveConterMatoAssociado'),
					exemplo: 'SEM MATO',
					formato: 'text',
					regex: new RegExp('m.*to.*a.*li', 'gi'),
					eixos: ['x'],
					qualidade: true,
				},
				{
					nome: i18n.t('bushHeightLine'),
					unidade: '(%)',
					key: 'alturaMatoLinha',
					descricao: i18n.t('deveConterAlturaMatoLinha'),
					exemplo: '10',
					formato: 'number',
					regex: new RegExp('alt.*m.*t.*li', 'gi'),
					eixos: ['x', 'y'],
					qualidade: true,
				},
				{
					nome: i18n.t('bushCoverLine'),
					unidade: '(%)',
					key: 'coberturaMatoLinha',
					descricao: i18n.t('deveConterCoberturaMatoLinha'),
					exemplo: '25',
					formato: 'number',
					regex: new RegExp('co.*m.*t.*li', 'gi'),
					eixos: ['x', 'y'],
					qualidade: true,
				},
				{
					nome: i18n.t('dominantBushBetween'),
					unidade: '(entrelinha)',
					key: 'matoDominanteEntrelinha',
					descricao: i18n.t('deveConterMatoDominanteEntrelinha'),
					exemplo: 'GRAMÍNEA',
					formato: 'text',
					regex: new RegExp('m.*t.*d.*en', 'gi'),
					eixos: ['x'],
					qualidade: true,
				},
				{
					nome: i18n.t('associatedBushBetween'),
					unidade: '(entrelinha)',
					key: 'matoAssociadoEntrelinha',
					descricao: i18n.t('deveConterMatoAssociadoEntrelinha'),
					exemplo: '30',
					formato: 'text',
					regex: new RegExp('m.*t.*as.*en', 'gi'),
					eixos: ['x'],
					qualidade: true,
				},
				{
					nome: i18n.t('bushHeightBetween'),
					key: 'alturaMatoEntrelinha',
					unidade: '(%)',
					descricao: i18n.t('deveConterAlturaMatoEntrelinha'),
					exemplo: '30',
					formato: 'number',
					regex: new RegExp('HT mato na entrelinha', 'gi'),
					eixos: ['x', 'y'],
					qualidade: true,
				},
				{
					nome: i18n.t('bushCoverBetween'),
					unidade: '(%)',
					key: 'coberturaMatoEntrelinha',
					descricao: i18n.t('deveConterCoberturaMatoEntrelinha'),
					exemplo: '50',
					formato: 'number',
					regex: new RegExp('Cobertura na entrelinha', 'gi'),
					eixos: ['x', 'y'],
					qualidade: true,
				},
			]
		},
		colunasObservacao() {
			return [
				{
					nome: i18n.t('observation'),
					key: 'observacao',
					descricao: i18n.t('observation'),
					exemplo: 'Texto livre',
					formato: 'text',
					regex: new RegExp('observa', 'gi'),
				},
			]
		},

		colunasMapeamento() {
			return [
				...this.colunasCadastrais,
				...this.colunasColeta,
				...this.colunasMatoCompeticao,
				...this.colunasObservacao,
			]
		},

		opcoesEixoX() {
			return this.colunasMapeamento
				.filter((f) => f.eixos && f.eixos.includes('x'))
				.map(({ nome, key, unidade, qualidade }) => {
					return {
						label: `${nome} ${unidade || ''}`,
						value: key,
						qualidade,
					}
				})
		},
		opcoesEixoY() {
			return this.colunasMapeamento
				.filter((f) => f.eixos && f.eixos.includes('y'))
				.map(({ nome, key, unidade, qualidade }) => {
					return {
						label: `${nome} ${unidade || ''}`,
						value: key,
						qualidade,
					}
				})
		},
		medicoesAtualizadasFormatadas() {
			return this.medicoesNormalizadas
				.filter((medicao) => this.medicoesAtualizadas.includes(medicao.id || medicao.idArvore))
				.map((m) => {
					// Função auxiliar para converter valores vazios/null para 0 em campos numéricos
					const convertToNumber = (value) => {
						if (value === null || value === undefined || value === '') return 0
						return typeof value === 'number' ? value : Number(value) || 0
					}

					// Função auxiliar para converter altura (pode ser null se vazia)
					const convertAltura = (value) => {
						if (value === null || value === undefined || value === '') return null
						return typeof value === 'number' ? value : Number(value) || null
					}

					return {
						idArvore: m.idArvore || m.id,
						categoriaDaArvore: m[this.bindColunas.categoriaDaArvore],
						CAP: m[this.bindColunas.cap],
						DAP: m[this.bindColunas.dap],
						Altura: convertAltura(m[this.bindColunas.ht]),
						categoriaFitossanidade: m[this.bindColunas.categoriaFitossanidade],
						intensidadeFitossanidade: m[this.bindColunas.intensidadeFitossanidade],
						coberturaMatoLinha: convertToNumber(m[this.bindColunas.coberturaMatoLinha]),
						alturaMatoLinha: convertToNumber(m[this.bindColunas.alturaMatoLinha]),
						tipoMatoDominante:
							m[this.bindColunas.tipoMatoDominante] === null
								? 0
								: m[this.bindColunas.tipoMatoDominante],
						tipoMatoAssociado:
							m[this.bindColunas.tipoMatoAssociado] === null
								? 0
								: m[this.bindColunas.tipoMatoAssociado],
						coberturaMatoEntrelinha: convertToNumber(m[this.bindColunas.coberturaMatoEntrelinha]),
						alturaMatoEntrelinha: convertToNumber(m[this.bindColunas.alturaMatoEntrelinha]),
						matoDominanteEntrelinha:
							m[this.bindColunas.matoDominanteEntrelinha] === null
								? 0
								: m[this.bindColunas.matoDominanteEntrelinha],
						matoAssociadoEntrelinha:
							m[this.bindColunas.matoAssociadoEntrelinha] === null
								? 0
								: m[this.bindColunas.matoAssociadoEntrelinha],
						diametroCopa: m[this.bindColunas.diametroCopa],
					}
				})
		},

		bindColunas() {
			return Object.fromEntries(this.colunaAtributo.map((ca) => [ca.value, ca.key]))
		},
		// missingDominantes() {
		//   return this.dominantesParcela.filter((d) => d.dominantes.length === 0)
		// },
		medicoesComInsights() {
			return this.medicoesNormalizadas.filter((f) => f.insights.length > 0)
		},
		boxPlotAlturaCategoria() {
			const categorias = this.categorias
				.filter(
					(categoria) =>
						categoria.ctga_tp_valida_dap === 'C' ||
						categoria.ctga_tp_valida_dap === 'O' ||
						categoria.ctga_tp_valida_ht === 'C' ||
						categoria.ctga_tp_valida_ht === 'O',
				)
				.map((categoria) => categoria.ctga_nm_nome)
			const boxPlotCategoria = []

			categorias.forEach((categoria) => {
				const alturas = this.medicoesNormalizadas
					.filter((medicao) => medicao[this.bindColunas.categoriaDaArvore] === categoria)
					.filter((medicao) => medicao[this.bindColunas.ht])
					.map((medicao) => Number(medicao[this.bindColunas.ht]?.toString().replace(',', '.')))
					.sort((a, b) => a - b)

				// Posicao dos quartis
				const QUANTIDADE_DE_ALTURAS = alturas.length
				const POSICAO_DA_MEDIANA = Math.floor(QUANTIDADE_DE_ALTURAS / 2)
				const POSICAO_PRIMEIRO_QUARTIL = Math.floor(POSICAO_DA_MEDIANA / 2)

				// Encontrando os limites
				const MEDIANA = alturas[POSICAO_DA_MEDIANA]
				const PRIMEIRO_QUARTIL = alturas[POSICAO_PRIMEIRO_QUARTIL]
				const TERCEIRO_QUARTIL = alturas[POSICAO_DA_MEDIANA + POSICAO_PRIMEIRO_QUARTIL]
				const LAS =
					TERCEIRO_QUARTIL + this.boxPlotSensibility * (TERCEIRO_QUARTIL - PRIMEIRO_QUARTIL)
				const LAI =
					PRIMEIRO_QUARTIL - this.boxPlotSensibility * (TERCEIRO_QUARTIL - PRIMEIRO_QUARTIL)

				boxPlotCategoria.push([
					categoria,
					{ PRIMEIRO_QUARTIL, LAI, MEDIANA, TERCEIRO_QUARTIL, LAS },
				])
			})
			return Object.fromEntries(boxPlotCategoria)
		},
		boxPlotDAPCategoria() {
			const categorias = this.categorias
				.filter(
					(categoria) =>
						categoria.ctga_tp_valida_dap === 'C' ||
						categoria.ctga_tp_valida_dap === 'O' ||
						categoria.ctga_tp_valida_ht === 'C' ||
						categoria.ctga_tp_valida_ht === 'O',
				)
				.map((categoria) => categoria.ctga_nm_nome)
			const boxPlotCategoria = []

			categorias.forEach((categoria) => {
				let daps = []

				if (this.bindColunas.dap === 'Nenhum') {
					daps = this.medicoesNormalizadas
						.filter((medicao) => medicao[this.bindColunas.categoriaDaArvore] === categoria)
						.filter((medicao) => medicao[this.bindColunas.cap])
						.map((medicao) =>
							Number(
								(
									Number(medicao[this.bindColunas.cap]?.toString().replace(',', '.')) / Math.PI
								).toFixed('2'),
							),
						)
						.sort((a, b) => a - b)
				} else {
					daps = this.medicoesNormalizadas
						.filter((medicao) => medicao[this.bindColunas.categoriaDaArvore] === categoria)
						.filter((medicao) => medicao[this.bindColunas.dap])
						.map((medicao) => Number(medicao[this.bindColunas.dap]?.toString().replace(',', '.')))
						.sort((a, b) => a - b)
				}

				// Posicao dos quartis
				const QUANTIDADE_DE_DAPS = daps.length
				const POSICAO_DA_MEDIANA = Math.floor(QUANTIDADE_DE_DAPS / 2)
				const POSICAO_PRIMEIRO_QUARTIL = Math.floor(POSICAO_DA_MEDIANA / 2)

				// Encontrando os limites
				const MEDIANA = daps[POSICAO_DA_MEDIANA]
				const PRIMEIRO_QUARTIL = daps[POSICAO_PRIMEIRO_QUARTIL]
				const TERCEIRO_QUARTIL = daps[POSICAO_DA_MEDIANA + POSICAO_PRIMEIRO_QUARTIL]
				const LAS =
					TERCEIRO_QUARTIL + this.boxPlotSensibility * (TERCEIRO_QUARTIL - PRIMEIRO_QUARTIL)
				const LAI =
					PRIMEIRO_QUARTIL - this.boxPlotSensibility * (TERCEIRO_QUARTIL - PRIMEIRO_QUARTIL)

				boxPlotCategoria.push([
					categoria,
					{ PRIMEIRO_QUARTIL, LAI, MEDIANA, TERCEIRO_QUARTIL, LAS },
				])
			})
			return Object.fromEntries(boxPlotCategoria)
		},
		boxPlotDAPAlturaCategoria() {
			const categorias = this.categorias
				.filter(
					(categoria) =>
						categoria.ctga_tp_valida_dap === 'C' ||
						categoria.ctga_tp_valida_dap === 'O' ||
						categoria.ctga_tp_valida_ht === 'C' ||
						categoria.ctga_tp_valida_ht === 'O',
				)
				.map((categoria) => categoria.ctga_nm_nome)
			const boxPlotCategoria = []

			categorias.forEach((categoria) => {
				let alturasDap = []

				if (this.bindColunas.dap === 'Nenhum') {
					alturasDap = this.medicoesNormalizadas
						.filter((medicao) => medicao[this.bindColunas.ht])
						.filter((medicao) => medicao[this.bindColunas.categoriaDaArvore] === categoria)
						.filter((medicao) => medicao[this.bindColunas.cap])
						.map(
							(medicao) =>
								Number(
									(
										Number(medicao[this.bindColunas.cap]?.toString().replace(',', '.')) / Math.PI
									).toFixed('2'),
								) / Number(medicao[this.bindColunas.ht]?.toString().replace(',', '.')),
						)
						.sort((a, b) => a - b)
				} else {
					alturasDap = this.medicoesNormalizadas
						.filter((medicao) => medicao[this.bindColunas.ht])
						.filter((medicao) => medicao[this.bindColunas.categoriaDaArvore] === categoria)
						.filter((medicao) => medicao[this.bindColunas.dap])
						.map(
							(medicao) =>
								Number(medicao[this.bindColunas.dap]?.toString().replace(',', '.')) /
								Number(medicao[this.bindColunas.ht]?.toString().replace(',', '.')),
						)
						.sort((a, b) => a - b)
				}

				// Posicao dos quartis
				const QUANTIDADE_DE_ALTURAS = alturasDap.length
				const POSICAO_DA_MEDIANA = Math.floor(QUANTIDADE_DE_ALTURAS / 2)
				const POSICAO_PRIMEIRO_QUARTIL = Math.floor(POSICAO_DA_MEDIANA / 2)

				// Encontrando os limites
				const MEDIANA = alturasDap[POSICAO_DA_MEDIANA]
				const PRIMEIRO_QUARTIL = alturasDap[POSICAO_PRIMEIRO_QUARTIL]
				const TERCEIRO_QUARTIL = alturasDap[POSICAO_DA_MEDIANA + POSICAO_PRIMEIRO_QUARTIL]
				const LAS =
					TERCEIRO_QUARTIL + this.boxPlotSensibility * (TERCEIRO_QUARTIL - PRIMEIRO_QUARTIL)
				const LAI =
					PRIMEIRO_QUARTIL - this.boxPlotSensibility * (TERCEIRO_QUARTIL - PRIMEIRO_QUARTIL)

				boxPlotCategoria.push([
					categoria,
					{ PRIMEIRO_QUARTIL, LAI, MEDIANA, TERCEIRO_QUARTIL, LAS },
				])
			})
			return Object.fromEntries(boxPlotCategoria)
		},

		boxPlotAlturaPlantio() {
			const boxPlotPlantio = []

			const plantiosECategorias = this.medicoesAgrupadasPorPlantioECategoria

			plantiosECategorias.forEach((plantio) => {
				const categorias = Object.keys(plantio.medicoes)
				categorias.forEach((categoria) => {
					const alturas = this.medicoesNormalizadas
						.filter((medicao) => medicao[this.bindColunas.plantio] === plantio.plantio)
						.filter((medicao) => medicao[this.bindColunas.categoriaDaArvore] === categoria)
						.filter((medicao) => medicao[this.bindColunas.ht])
						.map((medicao) => Number(medicao[this.bindColunas.ht]?.toString().replace(',', '.')))
						.sort((a, b) => a - b)

					if (alturas.length > 5) {
						// Posicao dos quartis
						const QUANTIDADE_DE_ALTURAS = alturas.length
						const POSICAO_DA_MEDIANA = Math.floor(QUANTIDADE_DE_ALTURAS / 2)
						const POSICAO_PRIMEIRO_QUARTIL = Math.floor(POSICAO_DA_MEDIANA / 2)

						// Encontrando os limites
						const MEDIANA = alturas[POSICAO_DA_MEDIANA]
						const PRIMEIRO_QUARTIL = alturas[POSICAO_PRIMEIRO_QUARTIL]
						const TERCEIRO_QUARTIL = alturas[POSICAO_DA_MEDIANA + POSICAO_PRIMEIRO_QUARTIL]
						const LAS =
							TERCEIRO_QUARTIL + this.boxPlotSensibility * (TERCEIRO_QUARTIL - PRIMEIRO_QUARTIL)
						const LAI =
							PRIMEIRO_QUARTIL - this.boxPlotSensibility * (TERCEIRO_QUARTIL - PRIMEIRO_QUARTIL)

						boxPlotPlantio.push({
							plantio: plantio.plantio,
							categoria: categoria,
							quartis: { PRIMEIRO_QUARTIL, LAI, MEDIANA, TERCEIRO_QUARTIL, LAS },
						})
					}
				})
			})

			return boxPlotPlantio

			// return Object.fromEntries(boxPlotPlantio)
		},

		boxPlotAlturaEstrato() {
			const alturas = this.medicoesNormalizadas
				.filter((medicao) => medicao[this.bindColunas.ht])
				.map((medicao) => Number(medicao[this.bindColunas.ht]?.toString().replace(',', '.')))
				.sort((a, b) => a - b)

			// Posicao dos quartis
			const QUANTIDADE_DE_ALTURAS = alturas.length
			const POSICAO_DA_MEDIANA = Math.floor(QUANTIDADE_DE_ALTURAS / 2)
			const POSICAO_PRIMEIRO_QUARTIL = Math.floor(POSICAO_DA_MEDIANA / 2)

			// Encontrando os limites
			const MEDIANA = alturas[POSICAO_DA_MEDIANA]
			const PRIMEIRO_QUARTIL = alturas[POSICAO_PRIMEIRO_QUARTIL]
			const TERCEIRO_QUARTIL = alturas[POSICAO_DA_MEDIANA + POSICAO_PRIMEIRO_QUARTIL]
			const LAS = TERCEIRO_QUARTIL + this.boxPlotSensibility * (TERCEIRO_QUARTIL - PRIMEIRO_QUARTIL)
			const LAI = PRIMEIRO_QUARTIL - this.boxPlotSensibility * (TERCEIRO_QUARTIL - PRIMEIRO_QUARTIL)

			return { PRIMEIRO_QUARTIL, LAI, MEDIANA, TERCEIRO_QUARTIL, LAS }
		},

		boxPlotAlturaParcela() {
			const parcelas = this.medicoesAgrupadasPorParcela.map((medicao) => medicao.parcela)
			const boxPlotParcela = []

			parcelas.forEach((parcela) => {
				const alturas = this.medicoesNormalizadas
					.filter((medicao) => medicao[this.bindColunas.parcela] === parcela)
					.filter((medicao) => medicao[this.bindColunas.ht])
					.map((medicao) => Number(medicao[this.bindColunas.ht]?.toString().replace(',', '.')))
					.sort((a, b) => a - b)

				// Posicao dos quartis
				const QUANTIDADE_DE_ALTURAS = alturas.length
				const POSICAO_DA_MEDIANA = Math.floor(QUANTIDADE_DE_ALTURAS / 2)
				const POSICAO_PRIMEIRO_QUARTIL = Math.floor(POSICAO_DA_MEDIANA / 2)

				// Encontrando os limites
				const MEDIANA = alturas[POSICAO_DA_MEDIANA]
				const PRIMEIRO_QUARTIL = alturas[POSICAO_PRIMEIRO_QUARTIL]
				const TERCEIRO_QUARTIL = alturas[POSICAO_DA_MEDIANA + POSICAO_PRIMEIRO_QUARTIL]
				const LAS =
					TERCEIRO_QUARTIL + this.boxPlotSensibility * (TERCEIRO_QUARTIL - PRIMEIRO_QUARTIL)
				const LAI =
					PRIMEIRO_QUARTIL - this.boxPlotSensibility * (TERCEIRO_QUARTIL - PRIMEIRO_QUARTIL)

				boxPlotParcela.push([parcela, { PRIMEIRO_QUARTIL, LAI, MEDIANA, TERCEIRO_QUARTIL, LAS }])
			})

			return Object.fromEntries(boxPlotParcela)
		},

		boxPlotDAPPlantio() {
			const boxPlotPlantio = []

			const plantiosECategorias = this.medicoesAgrupadasPorPlantioECategoria

			plantiosECategorias.forEach((plantio) => {
				const categorias = Object.keys(plantio.medicoes)
				categorias.forEach((categoria) => {
					let daps = []

					if (this.bindColunas.dap === 'Nenhum') {
						daps = this.medicoesNormalizadas
							.filter((medicao) => medicao[this.bindColunas.plantio] === plantio.plantio)
							.filter((medicao) => medicao[this.bindColunas.categoriaDaArvore] === categoria)
							.filter((medicao) => medicao[this.bindColunas.cap])
							.map((medicao) =>
								Number(
									(
										Number(medicao[this.bindColunas.cap]?.toString().replace(',', '.')) / Math.PI
									).toFixed('2'),
								),
							)
							.sort((a, b) => a - b)
					} else {
						daps = this.medicoesNormalizadas
							.filter((medicao) => medicao[this.bindColunas.plantio] === plantio.plantio)
							.filter((medicao) => medicao[this.bindColunas.categoriaDaArvore] === categoria)
							.filter((medicao) => medicao[this.bindColunas.dap])
							.map((medicao) => Number(medicao[this.bindColunas.dap]?.toString().replace(',', '.')))
							.sort((a, b) => a - b)
					}

					if (daps.length > 5) {
						// Posicao dos quartis
						const QUANTIDADE_DE_DAPS = daps.length
						const POSICAO_DA_MEDIANA = Math.floor(QUANTIDADE_DE_DAPS / 2)
						const POSICAO_PRIMEIRO_QUARTIL = Math.floor(POSICAO_DA_MEDIANA / 2)

						// Encontrando os limites
						const MEDIANA = daps[POSICAO_DA_MEDIANA]
						const PRIMEIRO_QUARTIL = daps[POSICAO_PRIMEIRO_QUARTIL]
						const TERCEIRO_QUARTIL = daps[POSICAO_DA_MEDIANA + POSICAO_PRIMEIRO_QUARTIL]
						const LAS =
							TERCEIRO_QUARTIL + this.boxPlotSensibility * (TERCEIRO_QUARTIL - PRIMEIRO_QUARTIL)
						const LAI =
							PRIMEIRO_QUARTIL - this.boxPlotSensibility * (TERCEIRO_QUARTIL - PRIMEIRO_QUARTIL)

						boxPlotPlantio.push({
							plantio: plantio.plantio,
							categoria: categoria,
							quartis: { PRIMEIRO_QUARTIL, LAI, MEDIANA, TERCEIRO_QUARTIL, LAS },
						})
					}
				})
			})

			return boxPlotPlantio

			// return Object.fromEntries(boxPlotPlantio)
		},

		boxPlotDAPEstrato() {
			let daps = []

			if (this.bindColunas.dap === 'Nenhum') {
				daps = this.medicoesNormalizadas
					.filter((medicao) => medicao[this.bindColunas.cap])
					.map((medicao) =>
						Number(
							(
								Number(medicao[this.bindColunas.cap]?.toString().replace(',', '.')) / Math.PI
							).toFixed('2'),
						),
					)
					.sort((a, b) => a - b)
			} else {
				daps = this.medicoesNormalizadas
					.filter((medicao) => medicao[this.bindColunas.dap])
					.map((medicao) => Number(medicao[this.bindColunas.dap]?.toString().replace(',', '.')))
					.sort((a, b) => a - b)
			}

			// Posicao dos quartis
			const QUANTIDADE_DE_DAPS = daps.length
			const POSICAO_DA_MEDIANA = Math.floor(QUANTIDADE_DE_DAPS / 2)
			const POSICAO_PRIMEIRO_QUARTIL = Math.floor(POSICAO_DA_MEDIANA / 2)

			// Encontrando os limites
			const MEDIANA = daps[POSICAO_DA_MEDIANA]
			const PRIMEIRO_QUARTIL = daps[POSICAO_PRIMEIRO_QUARTIL]
			const TERCEIRO_QUARTIL = daps[POSICAO_DA_MEDIANA + POSICAO_PRIMEIRO_QUARTIL]
			const LAS = TERCEIRO_QUARTIL + this.boxPlotSensibility * (TERCEIRO_QUARTIL - PRIMEIRO_QUARTIL)
			const LAI = PRIMEIRO_QUARTIL - this.boxPlotSensibility * (TERCEIRO_QUARTIL - PRIMEIRO_QUARTIL)

			return { PRIMEIRO_QUARTIL, LAI, MEDIANA, TERCEIRO_QUARTIL, LAS }
		},

		boxPlotDAPParcela() {
			const parcelas = this.medicoesAgrupadasPorParcela.map((medicao) => medicao.parcela)
			const boxPlotParcela = []

			parcelas.forEach((parcela) => {
				let daps = []

				if (this.bindColunas.dap === 'Nenhum') {
					daps = this.medicoesNormalizadas
						.filter((medicao) => medicao[this.bindColunas.parcela] === parcela)
						.filter((medicao) => medicao[this.bindColunas.dap])
						.map((medicao) =>
							Number(
								(
									Number(medicao[this.bindColunas.cap]?.toString().replace(',', '.')) / Math.PI
								).toFixed('2'),
							),
						)
						.sort((a, b) => a - b)
				} else {
					daps = this.medicoesNormalizadas
						.filter((medicao) => medicao[this.bindColunas.parcela] === parcela)
						.filter((medicao) => medicao[this.bindColunas.dap])
						.map((medicao) => Number(medicao[this.bindColunas.dap]?.toString().replace(',', '.')))
						.sort((a, b) => a - b)
				}

				// Posicao dos quartis
				const QUANTIDADE_DE_DAPS = daps.length
				const POSICAO_DA_MEDIANA = Math.floor(QUANTIDADE_DE_DAPS / 2)
				const POSICAO_PRIMEIRO_QUARTIL = Math.floor(POSICAO_DA_MEDIANA / 2)

				// Encontrando os limites
				const MEDIANA = daps[POSICAO_DA_MEDIANA]
				const PRIMEIRO_QUARTIL = daps[POSICAO_PRIMEIRO_QUARTIL]
				const TERCEIRO_QUARTIL = daps[POSICAO_DA_MEDIANA + POSICAO_PRIMEIRO_QUARTIL]
				const LAS =
					TERCEIRO_QUARTIL + this.boxPlotSensibility * (TERCEIRO_QUARTIL - PRIMEIRO_QUARTIL)
				const LAI =
					PRIMEIRO_QUARTIL - this.boxPlotSensibility * (TERCEIRO_QUARTIL - PRIMEIRO_QUARTIL)

				boxPlotParcela.push([parcela, { PRIMEIRO_QUARTIL, LAI, MEDIANA, TERCEIRO_QUARTIL, LAS }])
			})

			return Object.fromEntries(boxPlotParcela)
		},

		boxPlotDAPAlturaPlantio() {
			const boxPlotPlantio = []

			const plantiosECategorias = this.medicoesAgrupadasPorPlantioECategoria

			plantiosECategorias.forEach((plantio) => {
				const categorias = Object.keys(plantio.medicoes)
				categorias.forEach((categoria) => {
					let dapAlturas = []

					if (this.bindColunas.dap === 'Nenhum') {
						dapAlturas = this.medicoesNormalizadas
							.filter((medicao) => medicao[this.bindColunas.plantio] === plantio.plantio)
							.filter((medicao) => medicao[this.bindColunas.categoriaDaArvore] === categoria)
							.filter((medicao) => medicao[this.bindColunas.ht])
							.map(
								(medicao) =>
									Number(
										(
											Number(medicao[this.bindColunas.cap]?.toString().replace(',', '.')) / Math.PI
										).toFixed('2'),
									) / Number(medicao[this.bindColunas.ht]?.toString().replace(',', '.')),
							)
							.sort((a, b) => a - b)
					} else {
						dapAlturas = this.medicoesNormalizadas
							.filter((medicao) => medicao[this.bindColunas.plantio] === plantio.plantio)
							.filter((medicao) => medicao[this.bindColunas.categoriaDaArvore] === categoria)
							.filter((medicao) => medicao[this.bindColunas.ht])
							.map(
								(medicao) =>
									Number(medicao[this.bindColunas.dap]?.toString().replace(',', '.')) /
									Number(medicao[this.bindColunas.ht]?.toString().replace(',', '.')),
							)
							.sort((a, b) => a - b)
					}

					if (dapAlturas.length > 5) {
						// Posicao dos quartis
						const QUANTIDADE_DE_DAP_ALTURAS = dapAlturas.length
						const POSICAO_DA_MEDIANA = Math.floor(QUANTIDADE_DE_DAP_ALTURAS / 2)
						const POSICAO_PRIMEIRO_QUARTIL = Math.floor(POSICAO_DA_MEDIANA / 2)

						// Encontrando os limites
						const MEDIANA = dapAlturas[POSICAO_DA_MEDIANA]
						const PRIMEIRO_QUARTIL = dapAlturas[POSICAO_PRIMEIRO_QUARTIL]
						const TERCEIRO_QUARTIL = dapAlturas[POSICAO_DA_MEDIANA + POSICAO_PRIMEIRO_QUARTIL]
						const LAS =
							TERCEIRO_QUARTIL + this.boxPlotSensibility * (TERCEIRO_QUARTIL - PRIMEIRO_QUARTIL)
						const LAI =
							PRIMEIRO_QUARTIL - this.boxPlotSensibility * (TERCEIRO_QUARTIL - PRIMEIRO_QUARTIL)

						boxPlotPlantio.push({
							plantio: plantio.plantio,
							categoria: categoria,
							quartis: { PRIMEIRO_QUARTIL, LAI, MEDIANA, TERCEIRO_QUARTIL, LAS },
						})
					}
				})
			})

			return boxPlotPlantio

			// return Object.fromEntries(boxPlotPlantio)
		},

		boxPlotDAPAlturaParcela() {
			const parcelas = this.medicoesAgrupadasPorParcela.map((medicao) => medicao.parcela)
			const boxPlotParcela = []

			parcelas.forEach((parcela) => {
				let dapAlturas = []

				if (this.bindColunas.dap === 'nenhum') {
					dapAlturas = this.medicoesNormalizadas
						.filter((medicao) => medicao[this.bindColunas.parcela] === parcela)
						.filter((medicao) => medicao[this.bindColunas.ht])
						.map(
							(medicao) =>
								Number(
									(
										Number(medicao[this.bindColunas.cap]?.toString().replace(',', '.')) / Math.PI
									).toFixed('2'),
								) / Number(medicao[this.bindColunas.ht]?.toString().replace(',', '.')),
						)
						.sort((a, b) => a - b)
				} else {
					dapAlturas = this.medicoesNormalizadas
						.filter((medicao) => medicao[this.bindColunas.parcela] === parcela)
						.filter((medicao) => medicao[this.bindColunas.ht])
						.map(
							(medicao) =>
								Number(medicao[this.bindColunas.dap]?.toString().replace(',', '.')) /
								Number(medicao[this.bindColunas.ht]?.toString().replace(',', '.')),
						)
						.sort((a, b) => a - b)
				}

				// Posicao dos quartis
				const QUANTIDADE_DE_DAPS_ALTURAS = dapAlturas.length
				const POSICAO_DA_MEDIANA = Math.floor(QUANTIDADE_DE_DAPS_ALTURAS / 2)
				const POSICAO_PRIMEIRO_QUARTIL = Math.floor(POSICAO_DA_MEDIANA / 2)

				// Encontrando os limites
				const MEDIANA = dapAlturas[POSICAO_DA_MEDIANA]
				const PRIMEIRO_QUARTIL = dapAlturas[POSICAO_PRIMEIRO_QUARTIL]
				const TERCEIRO_QUARTIL = dapAlturas[POSICAO_DA_MEDIANA + POSICAO_PRIMEIRO_QUARTIL]
				const LAS =
					TERCEIRO_QUARTIL + this.boxPlotSensibility * (TERCEIRO_QUARTIL - PRIMEIRO_QUARTIL)
				const LAI =
					PRIMEIRO_QUARTIL - this.boxPlotSensibility * (TERCEIRO_QUARTIL - PRIMEIRO_QUARTIL)

				boxPlotParcela.push([parcela, { PRIMEIRO_QUARTIL, LAI, MEDIANA, TERCEIRO_QUARTIL, LAS }])
			})

			return Object.fromEntries(boxPlotParcela)
		},

		boxPlotDAPAlturaEstrato() {
			let dapAlturas = []

			if (this.bindColunas.dap === 'Nenhum') {
				dapAlturas = this.medicoesNormalizadas
					.filter((medicao) => medicao[this.bindColunas.ht])
					.map(
						(medicao) =>
							Number(
								(
									Number(medicao[this.bindColunas.cap]?.toString().replace(',', '.')) / Math.PI
								).toFixed('2'),
							) / Number(medicao[this.bindColunas.ht]?.toString().replace(',', '.')),
					)
					.sort((a, b) => a - b)
			} else {
				dapAlturas = this.medicoesNormalizadas
					.filter((medicao) => medicao[this.bindColunas.ht])
					.map(
						(medicao) =>
							Number(medicao[this.bindColunas.dap]?.toString().replace(',', '.')) /
							Number(medicao[this.bindColunas.ht]?.toString().replace(',', '.')),
					)
					.sort((a, b) => a - b)
			}

			// Posicao dos quartis
			const QUANTIDADE_DE_DAPS_ALTURAS = dapAlturas.length
			const POSICAO_DA_MEDIANA = Math.floor(QUANTIDADE_DE_DAPS_ALTURAS / 2)
			const POSICAO_PRIMEIRO_QUARTIL = Math.floor(POSICAO_DA_MEDIANA / 2)

			// Encontrando os limites
			const MEDIANA = dapAlturas[POSICAO_DA_MEDIANA]
			const PRIMEIRO_QUARTIL = dapAlturas[POSICAO_PRIMEIRO_QUARTIL]
			const TERCEIRO_QUARTIL = dapAlturas[POSICAO_DA_MEDIANA + POSICAO_PRIMEIRO_QUARTIL]
			const LAS = TERCEIRO_QUARTIL + this.boxPlotSensibility * (TERCEIRO_QUARTIL - PRIMEIRO_QUARTIL)
			const LAI = PRIMEIRO_QUARTIL - this.boxPlotSensibility * (TERCEIRO_QUARTIL - PRIMEIRO_QUARTIL)

			return { PRIMEIRO_QUARTIL, LAI, MEDIANA, TERCEIRO_QUARTIL, LAS }
		},
		/**
		 * verifica quais parcelas possui numero maior/menor que o esperado de medições
		 * @returns lista de parcelas com medições que possui número menor/maior de medições que esperado
		 */
		// parcelasComAtencaoEmMedicoes() {
		//   let medicoesComAtencao = this.arvoresMedidasPorParcela.map((pm) => {
		//     return {
		//       parcela: pm.parcela,
		//       arvoresMedidas: pm.arvoresMedidas.filter(
		//         (am) => am.maior || am.menor
		//       ),
		//     }
		//   })

		//   return medicoesComAtencao.filter((f) => f.arvoresMedidas.length)
		// },

		/**
		 * Verifica os mapeamentos que são obrigatórios se estão preenchidos
		 */
		mapeamentosObrigatorios() {
			const mensagens = []

			if (this.bindColunas.talhao === 'Nenhum') mensagens.push('Campo Talhão precisa ser mapeado')
			if (this.bindColunas.plantio === 'Nenhum') mensagens.push('Campo Plantio precisa ser mapeado')
			if (this.bindColunas.parcela === 'Nenhum') mensagens.push('Campo Parcela precisa ser mapeado')
			if (this.bindColunas.areaParc === 'Nenhum')
				mensagens.push('Campo Área da Parcela precisa ser mapeado')
			if (this.bindColunas.dataPlantio === 'Nenhum')
				mensagens.push('Campo Data de Plantio precisa ser mapeado')
			if (this.bindColunas.dataColeta === 'Nenhum')
				mensagens.push('Campo Data de Coleta precisa ser mapeado')
			if (this.bindColunas.linha === 'Nenhum') mensagens.push('Campo Linha precisa ser mapeado')
			if (this.bindColunas.arvore === 'Nenhum') mensagens.push('Campo Árvore precisa ser mapeado')

			// altura é obrigatório para IFQ, opcional para Tradicional
			if (this.model.tipoInventario === 'ifq') {
				if (this.bindColunas.ht === 'Nenhum') mensagens.push('Campo Altura precisa ser mapeado')
			}

			// inventário tradicional precisa que pelo menos um entre CAP e DAP seja mapeado, IFQ ambos são opcionais
			if (this.model.tipoInventario != 'ifq') {
				if (this.bindColunas.cap === 'Nenhum' && this.bindColunas.dap === 'Nenhum')
					mensagens.push('Campo CAP e/ou DAP precisa ser mapeado')
			}

			if (this.bindColunas.fuste === 'Nenhum') mensagens.push('Campo Fuste precisa ser mapeado')

			if (this.bindColunas.categoriaDaArvore === 'Nenhum')
				mensagens.push('Campo Categoria de Árvore precisa ser mapeado')

			return mensagens
		},

		dadosParaOutliersChart() {
			return this.medicoesNormalizadas.map((medicao) => {
				let dap = null
				let cap = null

				if (this.bindColunas.cap === 'Nenhum' && medicao[this.bindColunas.dap]) {
					dap = Number(medicao[this.bindColunas.dap]?.toString().replace(',', '.'))
					cap = Number((dap * Math.PI).toFixed(2))
				} else if (this.bindColunas.dap === 'Nenhum' && medicao[this.bindColunas.cap]) {
					cap = Number(medicao[this.bindColunas.cap]?.toString().replace(',', '.'))
					dap = Number((cap / Math.PI).toFixed(2))
				} else {
					cap = medicao[this.bindColunas.cap]
						? Number(medicao[this.bindColunas.cap]?.toString().replace(',', '.'))
						: undefined
					dap = medicao[this.bindColunas.dap]
						? Number(medicao[this.bindColunas.dap]?.toString().replace(',', '.'))
						: undefined
				}

				const altura = medicao[this.bindColunas.ht]
					? Number(medicao[this.bindColunas.ht]?.toString().replace(',', '.'))
					: undefined

				return {
					id: medicao.id || medicao.idArvore,
					dap: dap,
					cap: cap,
					ht: altura,
					diametroCopa: medicao[this.bindColunas.diametroCopa],
					categoriaDaArvore: medicao[this.bindColunas.categoriaDaArvore],
					plantio: medicao[this.bindColunas.plantio],
					parcela: medicao[this.bindColunas.parcela],
					areaParcela: medicao[this.bindColunas.areaParc],
					nivelRisco: medicao.nivelRisco,
					inconsistencias: medicao.inconsistencias,
					insights: medicao.insights,
					validacaoConsistencia:
						this.dadosValidacaoConsistencia.arvores?.find(
							(inconsistencia) => inconsistencia.id === (medicao.id || medicao.idArvore),
						)?.inconsistencias || [], //[...ValidacaoConsistencisStaticData.items.arvores[0].inconsistencias],
					dataPlantio: medicao[this.bindColunas.dataPlantio],
					dataColeta: medicao[this.bindColunas.dataColeta],
					tipoMatoDominante: medicao[this.bindColunas.tipoMatoDominante],
					tipoMatoAssociado: medicao[this.bindColunas.tipoMatoAssociado],
					alturaMatoLinha: medicao[this.bindColunas.alturaMatoLinha],
					coberturaMatoLinha: medicao[this.bindColunas.coberturaMatoLinha],
					matoDominanteEntrelinha: medicao[this.bindColunas.matoDominanteEntrelinha],
					matoAssociadoEntrelinha: medicao[this.bindColunas.matoAssociadoEntrelinha],
					alturaMatoEntrelinha: medicao[this.bindColunas.alturaMatoEntrelinha],
					coberturaMatoEntrelinha: medicao[this.bindColunas.coberturaMatoEntrelinha],
					categoriaFitossanidade: medicao[this.bindColunas.categoriaFitossanidade],
					intensidadeFitossanidade: medicao[this.bindColunas.intensidadeFitossanidade],
					coordenadaX: medicao[this.bindColunas.coordenadaX],
					coordenadaY: medicao[this.bindColunas.coordenadaY],
					inclinacao: medicao[this.bindColunas.inclinacao],
					talhao: medicao[this.bindColunas.talhao],
					linha: medicao[this.bindColunas.linha],
					arvore: medicao[this.bindColunas.arvore],
					fuste: medicao[this.bindColunas.fuste],
					estrato: this.findEstrato()['Código'],
					fazenda: this.findEstrato()['Fazenda'],
					corCategoriaArvore: this.corCategoria[medicao[this.bindColunas.categoriaDaArvore]],
					corCategoriaFitossanidade:
						this.corCategoriaFitossanidade[medicao[this.bindColunas.categoriaFitossanidade]],
				}
			})
		},

		/**
		 * Verifica se os dados que estão mapeados são do tipo correto
		 */
		dadoMapeadoDeTipoIncorreto() {
			const mensagens = []
			const colunas = Object.keys(this.bindColunas)

			for (const coluna of colunas) {
				if (this.bindColunas[coluna] !== 'Nenhum') {
					const primeiroRegistroEncontrado = 0
					const registroComColunaMapeada = this.medicoesNormalizadas.filter(
						(medicao) => medicao[this.bindColunas[coluna]],
					)[primeiroRegistroEncontrado]

					if (registroComColunaMapeada != undefined) {
						let valorDaColunaMapeada = registroComColunaMapeada[this.bindColunas[coluna]]
						const nomeColuna = this.colunasMapeamento.find(
							(colunaMapeamento) => colunaMapeamento.key === coluna,
						).nome

						switch (coluna) {
							case 'dataPlantio':
							case 'dataColeta':
								{
									const regExpData = /^(\d{2})\/(\d{2})\/(\d{4})$/

									if (!regExpData.test(valorDaColunaMapeada))
										mensagens.push(`Coluna ${nomeColuna} não está em formato de data`)
								}
								break
							case 'linha':
							case 'arvore':
							case 'fuste':
								{
									const regExpInt = /^\d+$/

									if (!regExpInt.test(valorDaColunaMapeada))
										mensagens.push(
											`Coluna ${nomeColuna} deve ser mapeado com um tipo inteiro positivo`,
										)
								}
								break
							case 'cap':
							case 'dap':
							case 'ht':
							case 'areaParc':
							case 'inclinacao':
								{
									const regExpDecimal = /^-?\d+(\.\d+)?$/

									valorDaColunaMapeada = valorDaColunaMapeada?.toString().replace(',', '.')
									if (!regExpDecimal.test(valorDaColunaMapeada))
										mensagens.push(
											`Coluna ${nomeColuna} deve ser mapeado com um tipo inteiro ou com casas decimais`,
										)
								}
								break
							case 'coordenadaX': // longitude
							case 'coordenadaY':
								{
									// latitude
									const regExpCoordenada =
										/^-?(\d{1,3}(\.\d+)?|([0-9]|[1-9][0-9]|1[0-7][0-9]|180)(\.0+)?)$/
									valorDaColunaMapeada = valorDaColunaMapeada?.toString().replace(',', '.').trim()
									if (!regExpCoordenada.test(valorDaColunaMapeada)) {
										mensagens.push(`Coluna ${nomeColuna} deve ser mapeada com tipo de coordenada`)
									}
								}
								break
						}
					}
				}
			}

			return mensagens
		},

		/**
		 * Só pode iniciar a validacao estrutural do arquivo quando os dados obrigatórios estiverem mapeados
		 * e quando os tipos dos dados que estão sendo mapeados estiverem corretos
		 */
		podeIniciarValidacaoEstrutural() {
			return (
				this.mapeamentosObrigatorios.length === 0 && this.dadoMapeadoDeTipoIncorreto.length === 0
			)
		},

		/**
		 * Faz relação entre arvores medidas por parcela e aplica regra de limites maximos e mínimos para cada parcela
		 * limiteSuperior = area da parcela / (espacamentoX * espacamentoY)) *  1.15;
		 * limiteInferior = area da parcela / (espacamentoX * espacamentoY)) *  0.85;
		 */
		arvoresMedidasPorParcela() {
			if (this.podeIniciarValidacaoEstrutural) {
				let arvoresParcela = this.medicoesAgrupadasPorParcelaEArvore
					.filter((f) => f.plantio != undefined)
					.map((mpa) => {
						const arvores = Object.keys(mpa.medicoes)
						const areaParcela = mpa.medicoes[arvores[0]][0][this.bindColunas.areaParc]
						const espacamento = espacamentoToObject(mpa.plantio.ptio_tx_espacamento)
						const limiteSuperior = limiteMaximoMedicoesParcela(areaParcela, espacamento)
						const limiteInferior = limiteMinimoMedicoesParcela(areaParcela, espacamento)
						return {
							limiteSuperior: limiteSuperior,
							limiteInferior: limiteInferior,
							maior: arvores.length > limiteSuperior,
							menor: arvores.length < limiteInferior,
							parcela: mpa.parcela,

							arvoresMedidas: arvores.map((arvore) => {
								return {
									arvore: arvore,
									medicoes: mpa.medicoes[arvore],
								}
							}),
						}
					})

				return arvoresParcela.filter(
					(ap) =>
						ap.arvoresMedidas.length < ap.limiteInferior ||
						ap.arvoresMedidas.length > ap.limiteSuperior,
				)
			}
			return []
		},

		/**
		 * organiza medições agrupadas por parcela e categoria dando destaque para as dominantes
		 * @returns lista de parcelas e suas respectivas dominantes
		 */
		dominantesParcela() {
			return this.medicoesAgrupadasPorParcelaECategoria.map((mp) => {
				return {
					parcela: mp.parcela,
					dominantes: mp.medicoes.DOMINANTE || [],
					plantio: mp.plantio,
					recomendado: mp.medicoes.DOMINANTE
						? Math.round(Number((mp.medicoes.DOMINANTE || [])[0][this.bindColunas.areaParc]) / 100)
						: 0,
				}
			})
		},

		/**
		 * Quando o número de dominantes for diferente de: Área da Parcela / 100, emite-se um aviso de atenção:
		 * "Parcela [cód.] tem X dominantes, o número ideal de dominantes é Y"
		 * Sendo assim, o número ideal de dominantes é exatamente  Área da Parcela / 100 aredondado
		 */
		dominantesEmAtencao() {
			if (this.podeIniciarValidacaoEstrutural)
				return this.dominantesParcela.filter((dp) => dp.dominantes.length != dp.recomendado)
			return []
		},

		/**
		 * Verifica quais parcelas possui dominantes além do ideal (1). Caso quantidade de dominantes em uma parcela for maior/menor que area da parcela / 100.
		 * @returns lista de parcelas que suas respectivas dominantes tem numero maior ou menor a area da parcela / 100.
		 */
		// parcelasComDominantesEmAtencao() {
		//   return this.dominantesParcela
		//     .filter((f) => f.dominantes.length)
		//     .filter(
		//       (f) =>
		//         f.dominantes.length >
		//         f.dominantes[0][this.bindColunas.areaParcela] / 100 ||
		//         f.dominantes.length <
		//         f.dominantes[0][this.dados] / 100
		//     )
		// },

		/**
		 * Verifica quais parcelas estão sem nenhuma dominante
		 * @returns lista de parcelas que nao possuem nunhuma dominante
		 */
		parcelasFaltandoDominante() {
			return this.dominantesParcela.filter((dm) => !dm.dominantes.length)
		},

		/**
		 * Agrupa medições agrupadas por parcelas em subagrupamento por categoria
		 * @returns lista de medições agrupadas por parcela e categoria
		 */
		medicoesAgrupadasPorParcelaECategoria() {
			//abordagem de deep copy para não alterar a referência do objeto
			return JSON.parse(JSON.stringify(this.medicoesAgrupadasPorParcela)).map((mp) =>
				Object.assign(mp, {
					medicoes: _.groupBy(mp.medicoes, this.bindColunas.categoriaDaArvore),
				}),
			)
		},

		presencaObrigatoriaDAP() {
			const categoriasDAPObrigatorio = this.categorias
				.filter((categoria) => categoria.ctga_tp_valida_dap === 'C')
				.map((categoria) => categoria.ctga_nm_nome)

			return this.medicoesNormalizadas.filter((medicao) => {
				// Recupera a categoria da arvore
				var categoriaDaArvore = medicao[this.bindColunas.categoriaDaArvore]

				// Verifica qual esta mapeado se é o DAP ou o CAP
				var mapeamentoDiametroCircunferencia =
					this.bindColunas.dap !== 'Nenhum'
						? this.bindColunas.dap
						: this.bindColunas.cap !== 'Nenhum'
							? this.bindColunas.cap
							: 'Nenhum'

				// Caso esteja retorna a categoria obrigatoria que nao esta com valor
				if (
					mapeamentoDiametroCircunferencia !== 'Nenhum' &&
					medicao[mapeamentoDiametroCircunferencia] != undefined
				) {
					var dap =
						medicao[mapeamentoDiametroCircunferencia] !== ''
							? parseFloat(medicao[mapeamentoDiametroCircunferencia]?.toString().replace(',', '.'))
							: ''

					return categoriasDAPObrigatorio.includes(categoriaDaArvore) && isNaN(dap)
				}

				// Caso a categoria esteja na lista das obrigatorias e nao foi mapeada pelo o usuario retorna ela para avisar na validacao para o usuario
				return categoriasDAPObrigatorio.includes(categoriaDaArvore)
			})
		},
		presencaObrigatoriaHT() {
			const categoriasHTObrigatorio = this.categorias
				.filter((categoria) => categoria.ctga_tp_valida_ht === 'C')
				.map((categoria) => categoria.ctga_nm_nome)

			return this.medicoesNormalizadas.filter((medicao) => {
				// Recupera a categoria da arvore
				var categoriaDaArvore = medicao[this.bindColunas.categoriaDaArvore]

				// Caso consiga mapear a altura faz a validacao
				if (this.bindColunas.ht !== 'Nenhum' && medicao[this.bindColunas.ht] != undefined) {
					var alturaDaArvore =
						medicao[this.bindColunas.ht] !== ''
							? parseFloat(medicao[this.bindColunas.ht]?.toString().replace(',', '.'))
							: ''

					return categoriasHTObrigatorio.includes(categoriaDaArvore) && isNaN(alturaDaArvore)
				}

				// Caso a categoria esteja na lista de alturas obrigatorias e nao foi mapeado pelo usuario retorna ela para avisar na validacao para o usuario
				return categoriasHTObrigatorio.includes(categoriaDaArvore)
			})
		},

		ausenciaObrigatoriaDAP() {
			const categoriasAusenciaDAPObrigatorio = this.categorias
				.filter((categoria) => categoria.ctga_tp_valida_dap === 'S')
				.map((categoria) => categoria.ctga_nm_nome)

			return this.medicoesNormalizadas.filter((medicao) => {
				// Recupera a categoria da arvore
				var categoriaDaArvore = medicao[this.bindColunas.categoriaDaArvore]

				// Verifica qual esta mapeado se é o DAP ou o CAP
				var mapeamentoDiametroCircunferencia =
					this.bindColunas.dap !== 'Nenhum'
						? this.bindColunas.dap
						: this.bindColunas.cap !== 'Nenhum'
							? this.bindColunas.cap
							: 'Nenhum'

				// Caso consiga mapear a altura faz a validacao
				if (
					mapeamentoDiametroCircunferencia !== 'Nenhum' &&
					medicao[mapeamentoDiametroCircunferencia] != undefined
				) {
					var dap =
						medicao[mapeamentoDiametroCircunferencia] !== ''
							? parseFloat(medicao[mapeamentoDiametroCircunferencia])?.toString().replace(',', '.')
							: ''

					return categoriasAusenciaDAPObrigatorio.includes(categoriaDaArvore) && isNaN(dap)
				}

				return (
					categoriasAusenciaDAPObrigatorio.includes(medicao[this.bindColunas.categoriaDaArvore]) &&
					!isNaN(medicao[mapeamentoDiametroCircunferencia])
				)
			})
		},

		ausenciaObrigatoriaHT() {
			const categoriasHTAusenciaObrigatoria = this.categorias
				.filter((categoria) => categoria.ctga_tp_valida_ht === 'S')
				.map((categoria) => categoria.ctga_nm_nome)

			return this.medicoesNormalizadas.filter((medicao) => {
				// Recupera a categoria da arvore
				var categoriaDaArvore = medicao[this.bindColunas.categoriaDaArvore]

				// Caso consiga maepar a altura faz a validação
				if (this.bindColunas.ht !== 'Nenhum' && medicao[this.bindColunas.ht] != undefined) {
					var alturaDaArvore =
						medicao[this.bindColunas.ht] !== ''
							? parseFloat(medicao[this.bindColunas.ht])?.toString().replace(',', '.')
							: ''
					return (
						categoriasHTAusenciaObrigatoria.includes(categoriaDaArvore) && isNaN(alturaDaArvore)
					)
				}

				return (
					categoriasHTAusenciaObrigatoria.includes(medicao[this.bindColunas.categoriaDaArvore]) &&
					!isNaN(medicao[this.bindColunas.ht])
				)
			})
		},

		dadoObrigatorio() {
			if (this.podeIniciarValidacaoEstrutural) {
				//mensagens relacionadas à categorias
				const mensagens = [
					...this.presencaObrigatoriaDAP.map(
						(podap) =>
							`DAP é obrigatório para categoria ${podap[this.bindColunas.categoriaDaArvore]}`,
					),
					...this.presencaObrigatoriaHT.map(
						(podap) =>
							`HT é obrigatório para categoria ${podap[this.bindColunas.categoriaDaArvore]}`,
					),
					...this.ausenciaObrigatoriaDAP.map(
						(podap) => `Categoria ${podap[this.bindColunas.categoriaDaArvore]} não pode ter DAP`,
					),
					...this.ausenciaObrigatoriaHT.map(
						(podap) => `Categoria ${podap[this.bindColunas.categoriaDaArvore]} não pode ter HT`,
					),
				]

				const parcelasSemArea = [
					...new Set(
						this.medicoesNormalizadas
							.filter((medicao) => {
								const valor = medicao[this.bindColunas.areaParc]
								const normalizado = valor?.toString().trim().replace(',', '.')
								return (
									normalizado === undefined ||
									normalizado === null ||
									normalizado === '' ||
									isNaN(Number(normalizado)) ||
									Number(normalizado) <= 0
								)
							})
							.map((medicao) => medicao[this.bindColunas.parcela]),
					),
				]
				parcelasSemArea.forEach((parcela) =>
					mensagens.push(i18n.t('areaParcelaObrigatoriaPorParcela', { parcela })),
				)

				return [...new Set(mensagens)]
			}
			return []
		},

		/**
		 * Data de coleta em branco ou invalida.
		 *
		 * Fica fora de podeIniciarValidacaoEstrutural de proposito: um erro de mapeamento ou de tipo
		 * em qualquer outra coluna zeraria essa checagem justamente quando ela mais importa, e o
		 * usuario ficaria sem saber que a data esta faltando. Tambem nao entra em dadoObrigatorio
		 * para nao duplicar a mensagem quando o mapeamento estiver limpo.
		 */
		dataColetaAusente() {
			if (this.bindColunas.dataColeta === 'Nenhum') return []

			const todasPreenchidas = this.medicoesNormalizadas.every((medicao) => {
				// parseDate('') devolve 01/01/1970 deslocado um mes, que passa no isValid().
				// Por isso a celula em branco precisa ser barrada antes de chegar no parseDate.
				const valor = medicao[this.bindColunas.dataColeta]?.toString().trim()
				return !!valor && parseDate(valor).isValid()
			})

			return todasPreenchidas ? [] : [i18n.t('dataColetaObrigatoria')]
		},

		parcelasVazias() {
			return this.medicoesNormalizadas.filter((medicao) => !medicao[this.bindColunas.parcela])
		},

		numeroNegativo() {
			if (this.podeIniciarValidacaoEstrutural) {
				const mensagens = []
				const capNegativo = this.medicoesNormalizadas.some(
					(medicao) => Number(medicao[this.bindColunas.cap]) < 0,
				)
				const dapNegativo = this.medicoesNormalizadas.some(
					(medicao) => Number(medicao[this.bindColunas.dap]) < 0,
				)
				const htNegativo = this.medicoesNormalizadas.some(
					(medicao) => Number(medicao[this.bindColunas.ht]) < 0,
				)

				if (capNegativo) mensagens.push('CAP não pode ser um número negativo')
				if (dapNegativo) mensagens.push('DAP não pode ser um número negativo')
				if (htNegativo) mensagens.push('HT não pode ser um número negativo')

				return mensagens
			}
			return []
		},

		dataColeta() {
			if (this.podeIniciarValidacaoEstrutural) {
				const mensagens = []

				if (
					this.medicoesNormalizadas.some(
						(medicao) =>
							parseDate(medicao[this.bindColunas.dataColeta]).getTime() > new Date().getTime(),
					)
				) {
					mensagens.push(
						`Data da coleta não pode ser superior a ${new Date().toLocaleDateString()}`,
					)
					mensagens.push(
						...this.medicoesNormalizadas
							.filter(
								(medicao) =>
									parseDate(medicao[this.bindColunas.dataColeta]).getTime() <
									parseDate(medicao[this.bindColunas.dataPlantio]).getTime(),
							)
							.map(
								(medicao) =>
									`Para o plantio ${medicao[this.bindColunas.plantio]} data da coleta precisa ser porterior a ${medicao[this.bindColunas.dataPlantio]}`,
							),
					)
				}

				return mensagens
			}
			return []
		},

		dataPlantio() {
			if (this.podeIniciarValidacaoEstrutural) {
				const dataPlantioCadastrada = (codigoPlantio) => {
					const plantio = this.plantios.find(
						(plantio) => plantio.plaes_tbg_ptio_plantio.ptio_cd_codigo === codigoPlantio,
					)
					if (!plantio) return undefined
					console.log('dataPlantioCadastrada', plantio.plaes_tbg_ptio_plantio.ptio_dt_plantio)
					return plantio.plaes_tbg_ptio_plantio.ptio_dt_plantio
				}

				const parsedMedicaoDate = (medicao) =>
					this.parseDateFunction(medicao[this.bindColunas.dataPlantio]).getTime()

				return this.medicoesNormalizadas
					.filter(
						(medicao) => !this.plantiosNaoCadastrados.includes(medicao[this.bindColunas.plantio]),
					)
					.filter((medicao) => {
						const cadastradoTime = new Date(
							dataPlantioCadastrada(medicao[this.bindColunas.plantio]),
						).getTime()
						const medicaoTime = parsedMedicaoDate(medicao)
						return medicaoTime !== cadastradoTime
					})
			}
			return []
		},

		plantiosNaoCadastrados() {
			if (this.podeIniciarValidacaoEstrutural) {
				const codigosPlantio = this.plantios.map(
					(plantio) => plantio.plaes_tbg_ptio_plantio.ptio_cd_codigo,
				)
				return [
					...new Set(
						this.medicoesNormalizadas
							.filter((medicao) => !codigosPlantio.includes(medicao[this.bindColunas.plantio]))
							.map((m) => m[this.bindColunas.plantio]),
					),
				]
			}
			return []
		},

		nenhumPlantioEstaCadastrado() {
			const codigosPlantiosCadastrados = [
				...new Set(this.plantios.map((plantio) => plantio.plaes_tbg_ptio_plantio.ptio_cd_codigo)),
			]
			const codigoDePlantiosDoCSV = [
				...new Set(this.medicoesNormalizadas.map((m) => m[this.bindColunas.plantio])),
			]

			return !codigoDePlantiosDoCSV.some((codigoDePlantioDoCSV) =>
				codigosPlantiosCadastrados.includes(codigoDePlantioDoCSV),
			)
		},

		categoriasNaoCadastradas() {
			if (this.podeIniciarValidacaoEstrutural) {
				const categorias = this.categorias.map((categoria) => categoria.ctga_nm_nome)
				return this.medicoesNormalizadas.filter(
					(medicao) => !categorias.includes(medicao[this.bindColunas.categoriaDaArvore]),
				)
			}
			return []
		},

		categoriasFitoNaoCadastradas() {
			if (this.podeIniciarValidacaoEstrutural && this.model.tipoInventario === 'ifq') {
				const categorias = this.categoriasFito.map((categoria) => categoria.nome)
				return this.medicoesNormalizadas.filter(
					(medicao) => !categorias.includes(medicao[this.bindColunas.categoriaFitossanidade]),
				)
			}
			return []
		},

		tipoMatoDominanteLinhaSemPadrao() {
			if (this.podeIniciarValidacaoEstrutural) {
				return this.medicoesNormalizadas.filter(
					(medicao) =>
						medicao[this.bindColunas.tipoMatoDominante] &&
						!['Sem mato', 'Germinação indefinida', 'Folha larga', 'Cipó', 'Gramínea'].includes(
							medicao[this.bindColunas.tipoMatoDominante],
						),
				)
			}

			return []
		},

		tipoMatoDominanteEntrelinhaSemPadrao() {
			if (this.podeIniciarValidacaoEstrutural) {
				return this.medicoesNormalizadas.filter(
					(medicao) =>
						medicao[this.bindColunas.matoDominanteEntrelinha] &&
						!['Sem mato', 'Germinação indefinida', 'Folha larga', 'Cipó', 'Gramínea'].includes(
							medicao[this.bindColunas.matoDominanteEntrelinha],
						),
				)
			}

			return []
		},

		tipoMatoAssociadoEntrelinhaSemPadrao() {
			if (this.podeIniciarValidacaoEstrutural) {
				return this.medicoesNormalizadas.filter(
					(medicao) =>
						medicao[this.bindColunas.matoAssociadoEntrelinha] &&
						!['Sem mato', 'Germinação indefinida', 'Folha larga', 'Cipó', 'Gramínea'].includes(
							medicao[this.bindColunas.matoAssociadoEntrelinha],
						),
				)
			}

			return []
		},

		semCoordenada() {
			if (this.podeIniciarValidacaoEstrutural) {
				return this.medicoesNormalizadas.filter(
					(medicao) =>
						!medicao[this.bindColunas.coordenadaX] || !medicao[this.bindColunas.coordenadaY],
				)
			}

			return []
		},

		semAlturaArvore() {
			if (this.podeIniciarValidacaoEstrutural && this.model.tipoInventario === 'ifq') {
				return this.medicoesNormalizadas.filter(
					(medicao) =>
						!medicao[this.bindColunas.ht] &&
						medicao[this.bindColunas.categoriaDaArvore] !== 'FALHA',
				)
			}

			return []
		},

		tipoMatoAssociadoLinhaSemPadrao() {
			if (this.podeIniciarValidacaoEstrutural) {
				return this.medicoesNormalizadas.filter(
					(medicao) =>
						medicao[this.bindColunas.tipoMatoAssociado] &&
						!['Sem mato', 'Germinação indefinida', 'Folha larga', 'Cipó', 'Gramínea'].includes(
							medicao[this.bindColunas.tipoMatoAssociado],
						),
				)
			}

			return []
		},

		/**
		 * Agrupa medições agrupadas por parcelas em subagrupamento por Arvore
		 * @returns lista de medições agrupadas por parcela e arvore
		 */
		medicoesAgrupadasPorParcelaEArvore() {
			return JSON.parse(JSON.stringify(this.medicoesAgrupadasPorParcela)).map((mp) =>
				Object.assign(mp, {
					plantio: mp.plantio,
					medicoes: _.groupBy(mp.medicoes, 'codigoArvore'),
				}),
			)
		},

		medicoesAgrupadasPorArvore() {
			return _.groupBy(JSON.parse(JSON.stringify(this.medicoesNormalizadas)), 'codigoArvore')
		},

		categoriasInconsistentes() {
			if (this.podeIniciarValidacaoEstrutural) {
				const arvoreFustes = Object.entries(this.medicoesAgrupadasPorArvore)
				return arvoreFustes.filter(
					(valores) =>
						!valores[1].every(
							(valor) =>
								valor[this.bindColunas.categoriaDaArvore] ===
								valores[1][0][this.bindColunas.categoriaDaArvore],
						),
				)
			}
			return []
		},

		medicoesAgrupadasPorFuste() {
			return _.groupBy(JSON.parse(JSON.stringify(this.medicoesNormalizadas)), 'codigo')
		},
		medicoesAgrupadasPorCategoria() {
			return _.groupBy(
				JSON.parse(JSON.stringify(this.medicoesNormalizadas)),
				this.bindColunas.categoriaDaArvore,
			)
		},

		/**
		 * Agrupa medições por plantio
		 * @returns {Object} medições agrupadas por plantio
		 */
		medicoesAgrupadasPorPlantio() {
			let agrupadasPorPlantio = _.groupBy(
				this.medicoesNormalizadas.filter(
					(medicao) => !this.plantiosNaoCadastrados.includes(medicao[this.bindColunas.plantio]),
				),
				this.bindColunas.plantio,
			)

			return agrupadasPorPlantio
		},

		/**
		 * Agrupa medições por nível de risco
		 * @returns {Object} medições agrupadas por nível de risco
		 */
		medicoesAgrupadasPorNivelRisco() {
			let agrupadasPorNivelRisco = _.groupBy(this.medicoesNormalizadas, 'nivelRisco')
			return agrupadasPorNivelRisco
		},

		/**
		 * Filtra medições que têm altura
		 * @returns {Array} medições com altura
		 */
		medicoesComAltura() {
			return this.medicoesNormalizadas.filter((medicao) => medicao[this.bindColunas.ht])
		},

		/**
		 * Verifica quais plantios não têm parcelas, caso ocorra
		 * @returns {Array} lista de plantios que não contém parcelas
		 */
		plantiosSemParcelas() {
			return this.medicoesAgrupadasPorPlantioEParcela.filter(
				(plantio) => !Object.keys(plantio.medicoes).length,
			)
		},

		/**
		 * Verifica quais plantio que possuem numero igual ou maior que duas parcelas
		 * @returns lista de plantios com numero de parcelas maior ou igual a dois
		 */
		// plantiosComParcelasEmAtencao() {
		//   return this.medicoesAgrupadasPorPlantioEParcela.filter(
		//     (plantio) => Object.keys(plantio.medicoes).length >= 2
		//   )
		// },

		/**
		 * Agruapa medições agrupadas por plantios em subagrupamentos por parcela
		 * @returns {Array} medições agrupadas por plantios e parcelas
		 */
		medicoesAgrupadasPorPlantioEParcela() {
			let plantios = Object.keys(this.medicoesAgrupadasPorPlantio)

			let agrupadasPorPlantioEParcela = plantios.map((plantio) => {
				return {
					plantio: plantio,
					medicoes: _.groupBy(this.medicoesAgrupadasPorPlantio[plantio], this.bindColunas.parcela),
				}
			})

			return agrupadasPorPlantioEParcela
		},

		/**
		 * Agrupa medições por plantio e subagrupamento de categoria
		 * @returns {Array} medições agrupadas por plantio e categoria
		 */
		medicoesAgrupadasPorPlantioECategoria() {
			let plantios = Object.keys(this.medicoesAgrupadasPorPlantio)

			let agrupadasPorPlantioECategoria = plantios.map((plantio) => {
				return {
					plantio: plantio,
					medicoes: _.groupBy(
						this.medicoesAgrupadasPorPlantio[plantio],
						this.bindColunas.categoriaDaArvore,
					),
				}
			})

			return agrupadasPorPlantioECategoria
		},

		/**
		 * Agrupa medições por parcela e adiciona seus respectivos plantios
		 */
		medicoesAgrupadasPorParcela() {
			let agrupadasPorParcela = _.groupBy(this.medicoesNormalizadas, this.bindColunas.parcela)

			return Object.keys(agrupadasPorParcela).map((f) => {
				return {
					parcela: f,
					medicoes: agrupadasPorParcela[f],
					plantio: this.plantios.find(
						(plantio) =>
							plantio.ptio_cd_codigo === agrupadasPorParcela[f][0][this.bindColunas.plantio],
					),
				}
			})
		},

		/**
		 * Verifica quais medições possui inconsistências
		 * @returns lista de medições inconsistentes
		 */
		medicoesInconsistentes() {
			return this.medicoesNormalizadas.filter((medicao) => medicao.inconsistencias.length)
		},

		/**
		 * Trata os dados das medições para facilitar a análise, adiciona atributos importantes, converte dados, etc...
		 * @returns Lista de medições normalizada
		 */
		medicoesNormalizadas() {
			const registros = this.content.data.length ? this.content.data : this.arvores

			// Descarta linhas sem Plantio APENAS quando a coluna tem valor em alguma linha
			// (limpeza de linhas parciais em arquivos mistos). Planilha com a coluna Plantio
			// inteira vazia não pode virar lista vazia silenciosa — as linhas seguem para o
			// mapeador, onde o validator de plantio aponta o problema visivelmente.
			const temAlgumPlantio = registros.some((medicao) => medicao.Plantio)
			const data = temAlgumPlantio
				? registros.filter((medicao) => medicao.Plantio !== '')
				: registros
			return data.map((medicao) => {
				return Object.assign(medicao, {
					codigo: `${medicao[this.bindColunas.parcela]}-${
						medicao[this.bindColunas.linha]
					}${medicao[this.bindColunas.arvore]}${medicao[this.bindColunas.fuste]}`,
					codigoArvore: `${medicao[this.bindColunas.parcela]}-${
						medicao[this.bindColunas.linha]
					}${medicao[this.bindColunas.arvore]}`,
					inconsistencias: [],
					insights: [],
					Nenhum: null,
				})
			})
		},
	},
}

export default mixins
